import { isEmpty } from 'lodash';

const checkInlineValidation = (keyName, value, prevData) => {
  if (isEmpty(prevData)) return true;

  return prevData[keyName] !== value;
};

export default checkInlineValidation;
